"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const conditional_1 = require("./conditional");
const defined_1 = require("./test/defined");
const not_1 = require("./unary/not");
const null_1 = require("./test/null");
const node_1 = require("../../node");
const and_1 = require("./binary/and");
class TwingNodeExpressionNullCoalesce extends conditional_1.TwingNodeExpressionConditional {
    constructor(left, right, lineno, columno) {
        let test = new and_1.TwingNodeExpressionBinaryAnd(new defined_1.TwingNodeExpressionTestDefined(left.clone(), 'defined', new node_1.TwingNode(), left.getTemplateLine(), left.getTemplateColumn()), new not_1.TwingNodeExpressionUnaryNot(new null_1.TwingNodeExpressionTestNull(left, 'null', new node_1.TwingNode(), left.getTemplateLine(), left.getTemplateColumn()), left.getTemplateLine(), left.getTemplateColumn()), left.getTemplateLine(), left.getTemplateColumn());
        super(test, left, right, lineno, columno);
        this.type = node_1.TwingNodeType.EXPRESSION_NULL_COALESCE;
        this.addType(node_1.TwingNodeType.EXPRESSION_NULL_COALESCE);
    }
    compile(compiler) {
        if (this.getNode('expr2').getType() === node_1.TwingNodeType.EXPRESSION_NAME) {
            this.getNode('expr2').setAttribute('always_defined', true);
        }
        return super.compile(compiler);
    }
}
exports.TwingNodeExpressionNullCoalesce = TwingNodeExpressionNullCoalesce;
